<template>
  <div>
    <van-field
      readonly
      clickable
      required
      :label="dateLable"
      name="classpicker"
      :value="nowTime"
      placeholder="请选择日期"
      @click="showClassPicker = true"
      :rules="[{ required: true, message: `请选择${dateLable}` }]"
    />
    <van-popup v-model="showClassPicker" round position="bottom">
      <van-nav-bar
        title="请选择日期"
        left-text="取消"
        right-text="确定"
        :left-arrow="false"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
      <van-row>
        <van-col span="18">
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate"
            type="date"
          >
          </van-datetime-picker>
        </van-col>
        <van-col span="6">
          <van-picker :columns="columns" @change="onChange" />
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { dateFormat } from "@/util/date.js";
import { Notify } from "vant";

export default {
  props: {
    dateStr: {
      type: Array,
      default: () => ["startTime", "startStr"],
    },
    dateLable: {
      type: String,
      default: "日期",
    },
    startTime: {
      type: String,
    },
  },
  data() {
    return {
      nowTime: "",
      showClassPicker: false,
      currentDate: new Date(),
      columnsValue: "上午",
      columns: ["上午", "下午"],
    };
  },

  methods: {
    onChange(picker, value, index) {
      this.columnsValue = value;
      console.log(index);
    },
    onClickLeft() {
      this.showClassPicker = false;
    },
    onClickRight() {
      var startMilliseconds = Date.parse(this.startTime.replace(/-/g, "/"));
      var nowMilliseconds = Date.parse(this.currentDate);
      if (
        this.dateLable == "请假结束日期" &&
        nowMilliseconds < startMilliseconds
      ) {
        Notify({ type: "warning", message: "请假结束时间必须大于开始时间。" });
      } else {
        this.nowTime =
          dateFormat(this.currentDate, "yyyy-MM-dd") + "  " + this.columnsValue;
        this.showClassPicker = false;
        let dateEvent = {};
        dateEvent[this.dateStr[0]] = dateFormat(
          this.currentDate,
          "yyyy-MM-dd 00:00:00"
        );
        dateEvent[this.dateStr[1]] = this.columnsValue;
        this.$emit("date-event", dateEvent);
      }
    },
  },
};
</script>


<style scoped>
</style>
